import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { map, Observable } from 'rxjs';

export const IsLoggedGuard: CanActivateFn | CanActivateChildFn = (
  route,
  _state
): Observable<boolean | import('@angular/router').UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    map((token) => {
      if (token) {
        return router.createUrlTree(['/dashboard'], {
          queryParams: route.queryParams,
        });
      }
      return true;
    })
  );
};
